// extracted by mini-css-extract-plugin
export default {"add":"drag-preview_add__348IS","delete":"drag-preview_delete__S+kP3"};